"use strict";

var _classCallCheck = require("/vercel/workpath0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/vercel/workpath0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/vercel/workpath0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/vercel/workpath0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");

var _wrapNativeSuper = require("/vercel/workpath0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/wrapNativeSuper");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var EthError = /*#__PURE__*/function (_Error) {
  _inherits(EthError, _Error);

  var _super = _createSuper(EthError);

  function EthError() {
    var _this;

    var httpError = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

    _classCallCheck(this, EthError);

    _this = _super.call(this, 'unknown');
    _this.httpError = httpError;
    return _this;
  }

  _createClass(EthError, null, [{
    key: "isEthError",
    value: function isEthError(err) {
      return typeof err === 'object' && err && err instanceof this;
    }
  }]);

  return EthError;
}( /*#__PURE__*/_wrapNativeSuper(Error));

exports.EthError = EthError;